export const messages = {
  en: {
    productDetail: {
      title: 'Product Details',
      productId: 'Product ID:',
      categoryName: 'Product Group:',
      prodName: 'Product Name:',
      shName: 'Warehouse:',
      sales: 'Sales:',
      stock: 'Stock:',
      price: 'Price:',
      sort: 'Sort:',
      stateName: 'Status:',
      createTime: 'Create Time:'
    },
    productDetailSpec: {
      specName: 'Spec Name',
      stock: 'Stock',
      sales: 'Sales',
      price: 'Price/Points',
      costPrice: 'Cost Price',
      ownerPrice: 'Owner Price',
      vipPrice: 'VIP Price',
      otPrice: 'Market Price',
      deduction: 'Deduction',
      barCode: 'Barcode'
    },
    productDetailAppraise: {
      prodName: 'Product Name',
      appraiseUserName: 'User',
      appraiseScore: 'Rating',
      context: 'Content',
      imgPath: 'Images',
      createTime: 'Comment Time'
    },
    productDetailLabel: {
      labelName: 'Label Name',
      productId: 'Product ID',
      productImage: 'Product Image',
      categoryName: 'Product Group',
      productName: 'Product Name'
    },
    productDetailInstock: {
      orderId: 'Order No',
      personName: 'Applicant',
      createTime: 'Apply Time',
      stateName: 'Status',
      prodName: 'Product Name',
      specName: 'Spec',
      prodCount: 'Quantity',
      price: 'Price',
      amount: 'Amount'
    },
    productDetailGroup: {
      id: 'ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      groupCount: 'Group Members',
      groupPrice: 'Group Price',
      singlePrice: 'Single Price',
      status: 'Status',
      validity: 'Validity',
      rebateFlag: 'Rebate',
      leaderRebate: 'Leader Rebate'
    },
    productDetailSeckill: {
      productName: 'Product Name',
      seckillPeriod: 'Seckill Period',
      validPurchase: 'Valid Purchase',
      onePurchase: 'One Purchase',
      killPrice: 'Kill Price',
      singlePrice: 'Single Price',
      limit: 'Limit',
      status: 'Status',
      validity: 'Validity'
    }
  },
  zh: {
    productDetail: {
      title: '商品详情',
      productId: '商品ID：',
      categoryName: '商品分组：',
      prodName: '商品名称：',
      shName: '仓库：',
      sales: '销量：',
      stock: '库存：',
      price: '价格：',
      sort: '排序：',
      stateName: '状态：',
      createTime: '注册时间：'
    },
    productDetailSpec: {
      specName: '规格名称',
      stock: '库存',
      sales: '销量',
      price: '金额/积分',
      costPrice: '成本价',
      ownerPrice: '业主价',
      vipPrice: '会员价格',
      otPrice: '市场价',
      deduction: '抵扣金',
      barCode: '条形码'
    },
    productDetailAppraise: {
      prodName: '商品名称',
      appraiseUserName: '用户',
      appraiseScore: '评分',
      context: '内容',
      imgPath: '图片',
      createTime: '评论时间'
    },
    productDetailLabel: {
      labelName: '标签名称',
      productId: '商品ID',
      productImage: '商品图片',
      categoryName: '商品分组',
      productName: '商品名称'
    },
    productDetailInstock: {
      orderId: '订单编号',
      personName: '申请人',
      createTime: '申请时间',
      stateName: '状态',
      prodName: '商品名称',
      specName: '规格',
      prodCount: '数量',
      price: '价格',
      amount: '金额'
    },
    productDetailGroup: {
      id: '编号',
      productImage: '商品图片',
      productName: '商品名称',
      groupCount: '拼团人数',
      groupPrice: '拼团金额',
      singlePrice: '单买金额',
      status: '状态',
      validity: '有效期',
      rebateFlag: '是否返佣',
      leaderRebate: '团长返佣'
    },
    productDetailSeckill: {
      productName: '产品名称',
      seckillPeriod: '秒杀时段',
      validPurchase: '有效期内购买',
      onePurchase: '一次购买数量',
      killPrice: '秒杀金额',
      singlePrice: '单买金额',
      limit: '限量',
      status: '状态',
      validity: '有效期'
    }
  }
}